import { render, staticRenderFns } from "./StatusTopic.vue?vue&type=template&id=725658a2&"
import script from "./StatusTopic.vue?vue&type=script&lang=js&"
export * from "./StatusTopic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports